document.addEventListener('rebuy:smartcart.show', (event) => {
    const smartcart = event.detail.smartcart;
    console.log('Smart Cart opened!');
      const optgroup = document.querySelector('.rebuy-cart__flyout-item.product-gengyve-sample .rebuy-cart__flyout-item-subscription select.rebuy-select optgroup[label="Pay Full Price"]');
if (optgroup) optgroup.remove(); 
});

/* limit quantity for tagged products in Smart Cart */
function limitItemQuantities() {
  setTimeout(() => {
    /* pull in all the cart items */
    const cartItems = Rebuy.SmartCart.items();
    /* check for product tag and quantity, lower quantity if needed */
    cartItems.forEach(item => {
      if (item.product?.tags.includes("sample-product") && item.quantity > 5) { /* <-- this is the max quantity for tagged products */
        /* lower item quantity back to the maximum */
        Rebuy.Cart.setItemQuantity(item, 3) /* <-- this is the max quantity for tagged products */
      }
    })
  }, 300);
}
document.addEventListener('rebuy:cart.change', limitItemQuantities)

$(document).ready(function () {

const copyTrigger = document.querySelector(".triggerCopy");

if (copyTrigger) {
  copyTrigger.addEventListener("click", function(e) {
    e.preventDefault();
    e.stopPropagation();
    let spanText = this.querySelector("span")?.innerText || this.querySelector("span")?.textContent;
    if (spanText) {
      navigator.clipboard.writeText(spanText).then(() => {
        console.log("Copied:", spanText);
        alert("Copied: " + spanText);
      }).catch(err => console.error("Error copying text: ", err));
    }
  });
}


  $(document).on("click", ".block__cb label", function () {
      let inputValue = $(this).closest(".block__cb").find("input").val();
      console.log(inputValue);
      var disText = $(document).find('.discount-box .hidden div[data-id="'+inputValue+'"]').html();
      console.log(disText);
      $(document).find('.discount-box__text').html(disText);
  });
  
    // Attach click event to all anchor tags with href starting with '#'
    $('a[href^="#"]').on('click', function (e) {
        e.preventDefault(); // Prevent default anchor behavior

        // Get the target element's position
        const target = $(this.getAttribute('href'));

        if (target.length) {
            // Animate smooth scroll to the target
            $('html, body').animate({
                scrollTop: target.offset().top
            }, 800); // 800ms duration for the scroll
        }
    });

     $(document).on('click','.page-subscription a[href="/products/gengyve-sample"]', function(e){
        e.preventDefault();
        var id = 45896527413483;
        var qty = 1; 
        var inputId = $(this).parent().find('fieldset input[type="radio"]:checked').attr('id');
        var plan = 10568597739; 
        //console.log(inputId);
        console.log(plan);
        let formData = {
         'items': [{
          'id': id,
          'quantity': qty,
          'selling_plan': plan,
          }]
        };
          $.ajax({
          type:"post",
          dataType: "json",
          url: '/cart/add.js',
          data:{quantity:qty,id:id, selling_plan: plan},
          success: function(data){
            window.location.href = '/checkout';
          }
        });
      })
  
});
var swiper = new Swiper(".featured-info-slider-mobile", {
  scrollbar: {
    el: ".swiper-scrollbar",
    hide: false,
  },
});
var swiper = new Swiper(".featured__offer-slider", {
  slidesPerView: 1,
  spaceBetween: 10,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
});
var swiper = new Swiper(".reviewSlider", {
  slidesPerView: 1,
  spaceBetween: 10,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
});
 (function() {

   var megamenuDropdown = function () {
  const detailsEl = document.querySelectorAll('.header__inline-menu .mega-menu');

  detailsEl.forEach((detail) => {
    const summary = detail.querySelector("summary");
    const dropdown = detail.querySelector(".mega-menu__content");

    const showDropdown = () => {
      if (!dropdown) return;
      gsap.set(dropdown, { visibility: "visible" });
      gsap.to(dropdown, { opacity: 1, y: 0, duration: 0.45, ease: "power2.out" });
    };

    const hideDropdown = () => {
      if (!dropdown) return;
      gsap.to(dropdown, {
        opacity: 0,
        y: 8,
        duration: 0.6,
        ease: "power2.in",
        onComplete: () => {
          gsap.set(dropdown, { visibility: "hidden" });
        },
      });
    };

    summary.addEventListener("click", (e) => {
      e.preventDefault();

      const isOpen = detail.hasAttribute("open");

      // Close all menus first
      detailsEl.forEach((d) => {
        d.removeAttribute("open");
        d.setAttribute("aria-expanded", "false");
        const dDropdown = d.querySelector(".mega-menu__content");
        if (dDropdown) {
          gsap.set(dDropdown, { visibility: "hidden", opacity: 0, y: 8 });
        }
      });

      if (!isOpen) {
        detail.setAttribute("open", "");
        detail.setAttribute("aria-expanded", "true");
        showDropdown();
      } else {
        detail.removeAttribute("open");
        detail.setAttribute("aria-expanded", "false");
        hideDropdown();
      }
    });
  });
};


   
  var accordion = function() {
    $('.accordion').find('.accordion-toggle').click(function(){
      if(false == $(this).parent().find('.accordion-content').is(':visible')) {
        $('.accordion-box .accordion-toggle').removeClass('active');
        $('.accordion-box .accordion-content').removeClass('active');
        $('.accordion-box .accordion-content').slideUp();
      }
      //Expand or collapse this panel
      $(this).toggleClass('active');
      $(this).parent().find('.accordion-content').toggleClass('active');
      //$(this).parent().find('.accordion-content').slideToggle('fast');
    });
  };
 var featuredOfferslider = function() {
    // $('.featured__offer-slider').flickity({
    //   // options
    //   cellAlign: 'left',
    //   wrapAround: true,
    //   pageDots: false,
    //   prevNextButtons: true , 
    // });
  };
   var offerAddToCart = function() {
    $(document).on('click', '.featured__offer-atc', function(e) {
        e.preventDefault();
        var id = $(this).data('id');
        var qty = $(this).data('qty'); 
        var inputId = $(this).parent().find('fieldset input[type="radio"]:checked').attr('id');
        var plan = $(this).parent().find('fieldset input[type="radio"]:checked').val(); 
        var template = $(this).data('template');

        console.log(inputId);
        console.log(plan);

        // Fetch cart data first
        jQuery.getJSON('/cart.js', function(cart) {
            let itemExists = cart.items.some(item => item.handle === "gengyve-sample");

            if (itemExists && template === 'sample-product' ) {
                alert("The max items have already been added to the cart.");
                return; // Stop execution if item exists
            }

            // Prepare data for AJAX request
            let formData = {
                'items': [{
                    'id': id,
                    'quantity': qty,
                    'selling_plan': plan,
                }]
            };

            // Proceed with adding to cart
            $.ajax({
                type: "post",
                dataType: "json",
                url: '/cart/add.js',
                data: formData,
                success: function(data) {
                        window.location.href = '/checkout';
                   
                }
            });

        });
    });
};

    var cardReview = new Swiper(".cardSlider", {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
      },
    });
    var moduleOneslider = new Swiper(".moduleone", {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
      },
    });
  accordion();
  featuredOfferslider();
  offerAddToCart();
  if (document.querySelector('.cardSlider')) {cardReview()};
  if (document.querySelector('.moduleone')) {  moduleOneslider()};
   megamenuDropdown();

  $(document).on('shopify:section:load', function(event) { 
    accordion();
    featuredOfferslider();
    offerAddToCart();
    if (document.querySelector('.cardSlider')) {cardReview()};
    if (document.querySelector('.moduleone')) {  moduleOneslider()};
    megamenuDropdown();
  var swiper = new Swiper(".featured__offer-slider", {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
  });
    var swiper = new Swiper(".reviewSlider", {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
    });
  });
}());
 